module.exports = "https://cdn.dove.it/_next/static/public/assets/press/logo-ilsecolo.ed4f1a6687d05d9823d36f0b00e2a580.png";